<template>
    <v-card class="score-chart ma-1">
        <v-container>
            <v-card flat class="ma-1 pa-2 score-trans">
                <v-responsive>
                    <v-card-title dense class="caption-font">Bookings/year</v-card-title>
                    <v-card-subtitle>Number of bookings over the year (YTD) compared to last 2 years</v-card-subtitle>
                    <v-container>
                        <div style="height: 250px; width: 100%;">
                        <canvas id="seasonv1-chart1" height="300" style="width:100%;"></canvas>
                        </div>
                    </v-container>
                </v-responsive>
            </v-card>
            <v-card-actions></v-card-actions>
        </v-container>
    </v-card>
</template>

<script>

    import mxbookingschart from '../mixins/season_chart_V3';

    import { Chart, registerables } from 'chart.js'
    Chart.register(...registerables)    

    import {bus} from "../../../../main";

    export default {
        data() {
            return {
                chart: null,
            }
        },
        created(){ // set up event bus listener here on created event
            this.loadData('load');
            bus.$on("refresh", () => {
                this.loadData('refresh');                
            });
        },                  
        mounted(){            

        },    
        mixins:[mxbookingschart],
        methods:{
            refreshChart(object){
                this.chart.data.labels = object.data.labels;
                let i = 0;
                this.chart.data.datasets.forEach((dataset) => {
                   dataset.data = object.data.datasets[i].data;
                   i++;
                });
                this.chart.options = object.options;
                this.chart.update();
            },
            getBookingData(param){
                return this.$axios
                    .post("ares/json/ares/syst/dashboard/getHighSeasonBookingsv5.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHighSeasonBookings"
                    },
                    getHighSeasonBookings: {
                        year: param,
                    }
                });
            },
            loadData(param){

                var Year0 = new Date().getFullYear();
                var Year1 = Year0 - 1;
                var Year2 = Year0 - 2;
            
                const promise1 = this.getBookingData(Year0);
                const promise2 = this.getBookingData(Year1);
                const promise3 = this.getBookingData(Year2);

                Promise.all([promise1, promise2, promise3]).then(res => {
                    if(param ==='load'){
                        const ctx = document.getElementById('seasonv1-chart1').getContext('2d');
                        this.chart = new Chart(ctx, this.createBarData(res[0].data.getHighSeasonBookings, 
                                                                       res[1].data.getHighSeasonBookings,
                                                                       res[2].data.getHighSeasonBookings)); // horizontalBar, bar                                
                    } else {
                        this.refreshChart(this.createBarData(res[0].data.getHighSeasonBookings, 
                                                             res[1].data.getHighSeasonBookings,
                                                             res[2].data.getHighSeasonBookings));
                    }
                });
            },     
        }
    }
</script>

<style scoped>
    .score-chart {
        background: url('../assets/not_a_sunset.png') !important;
        background-size: cover !important;
    }
    .caption-font {
        font-size: 30px;
        font-weight: bold;
    }
    .score-trans {
        background: transparent !important;
    }
</style>